import { useEffect } from "react"

import { useRealtimeReload } from "@/hooks/use-realtime-reload"
import { subscribe } from "@/lib/realtime"
import { showToast } from "@/lib/toast"

/** Applies app-wide realtime events: background-job toasts and bank import progress. */
export function RealtimeEvents() {
  useEffect(
    () =>
      subscribe("UserChannel", (event) => {
        if (event.type === "flash") showToast(event.kind, event.message)
      }),
    [],
  )

  useRealtimeReload((event) => event.type === "bank_sync.changed", ["initial_bank_sync"])

  return null
}
